<template>
  <div class="c-lyric">
    <div class="copy">
      <tooltip :label="$t('global.copyLyrics')" placement="center" maxWidth="220px" :whiteSpaceWrap="false">
        <img class="copy__img" src="@/assets/searchResults/icon_copy.svg" @click="doCopy" />
      </tooltip>
    </div>

    <div class="c-lyric__content">
      <p class="lyric-text">
        {{ data }}
      </p>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { useMessage } from 'naive-ui';
import { useI18n } from 'vue-i18n';
import Tooltip from '@/components/Global/Tooltip.vue';

export default defineComponent({
  name: 'Lyric',
  components: {
    Tooltip,
  },
  props: {
    data: {
      type: String,
      default: '',
    },
  },
  setup() {
    const message = useMessage();
    const { t } = useI18n();

    return {
      t,
      message,
    };
  },
  methods: {
    copyInfo() {
      return this.data;
    },
    doCopy() {
      this.$copyText(this.copyInfo()).then(
        () => {
          this.message.success(this.t('msg.copySuccess'));
        },
        () => {
          this.message.error(this.t('msg.copyFail'));
        },
      );
    },
  },
});
</script>
<style lang="scss" scoped>
.c-lyric {
  margin: 0 20px;
  // border-right: 1px solid $c-assist3;
  position: relative;

  &__content {

    height: 150px;
    overflow: auto;

    &::-webkit-scrollbar {
      width: 6px;
      border-radius: 3px;
      background: $c-assist3;
    }

    &::-webkit-scrollbar-thumb {
      // width: 2px;
      border-radius: 3px;
      background: $c-main;
      position: relative;
    }
  }
}

.lyric-text {
  @include font-style($c-assist6, 14, normal, 0.8px, 26px);
  white-space: pre-line;
  @include padding(0 35px 0 0);
}

.copy {
  flex: none;
  width: 18px;
  @include position(tr, 0, 10px);

  &__img {
    width: 100%;
    cursor: pointer;
  }
}
</style>
